import ArchiveListWon from './archive-won'
import ArchiveListLostInquiries from './archive-lost-inquiries'
import ArchiveListLostTransactions from './archive-lost-transactions'
import ArchiveListUnrespondedLeads from './archive-unresponded-leads'

export default [
  {
    value: 'won-leads',
    title: 'Won Leads',
    component: ArchiveListWon,
  },
  {
    value: 'lost-inquiries',
    title: 'Lost Inquiries',
    component: ArchiveListLostInquiries,
  },
  {
    value: 'lost-transactions',
    title: 'Lost Transactions',
    component: ArchiveListLostTransactions,
  },
  {
    value: 'unresponded-leads',
    title: 'Unresponsed Leads',
    component: ArchiveListUnrespondedLeads,
  },
]
